import './ViewTeamsAlertMessage.scss';

import * as React from 'react';
import { useState } from 'react';

import {
  SlDropdown,
  SlMenu,
  SlMenuItem,
} from '@shoelace-style/shoelace/dist/react';
import { translate } from '~l10n/client';
import { useAtom } from 'jotai';

import { AlertMessage } from '~shared/components/AlertMessage';
import { IconChevron } from '~shared/components/icons/standard';
import { Link } from '~shared/components/Link';
import { selectedTeamIdAtom } from '~teacher/components/Account/atoms';
import { useTeams } from '~teacher/hook/team';

export function ViewTeamsAlertMessage() {
  const teamsQuery = useTeams();
  const [selectedTeamId, setSelectedTeamId] = useAtom(selectedTeamIdAtom);

  const selectedTeam = useTeams({
    select: (teams) => teams.find((team) => team.id === selectedTeamId),
  });

  const [isOpen, setIsOpen] = useState(false);

  if (!teamsQuery.data || !selectedTeam) {
    return null;
  }

  return (
    <AlertMessage align="center" showIcon tone="info" wrap>
      <span className="leading-10" id="button-label">
        {translate('Viewing plans for Team:')}
      </span>
      <SlDropdown
        className="team-menu"
        onSlShow={() => setIsOpen(true)}
        onSlHide={() => setIsOpen(false)}
      >
        <button
          aria-haspopup="menu"
          className={`flex font-sans text-base group relative rounded-2 h-10 border-solid max-w-70 overflow-hidden font-sans font-600 appearance-none outline-none select-none transition ease-in-out duration-100 bg-transparent cursor-pointer ${
            isOpen ? 'border-cyan-500' : 'border-transparent'
          }`}
          value={selectedTeam.data?.displayName}
          aria-labelledby="button-label"
          slot="trigger"
        >
          <div className="flex-shrink flex-grow-0 whitespace-no-wrap truncate min-w-0 leading-8">
            {selectedTeam.data?.displayName}
          </div>
          <div className="text-amber-900 grid">
            <IconChevron direction="down" />
          </div>
        </button>

        <SlMenu
          onSlSelect={(evt) => {
            const id = (evt as any).detail.item.value;
            setSelectedTeamId(id);
          }}
        >
          {(teamsQuery.data ?? []).map(({ id, displayName }) => (
            <SlMenuItem
              type="checkbox"
              value={id}
              checked={selectedTeamId === id}
              key={id}
            >
              <span className="font-sans text-base">{displayName}</span>
            </SlMenuItem>
          ))}
        </SlMenu>
      </SlDropdown>
      <Link className="leading-10" href="#profile/billing">
        {translate('View Team')}
      </Link>
    </AlertMessage>
  );
}
